<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
